import { cva } from 'class-variance-authority'

export const lawVariants = {
  text: {
    base: cva([
      'flex',
      'flex-col',
      'items-stretch',
      'pt-2xs',
      'pb-m',
      'gap-xs',
    ], {
      variants: {
        selected: {
          true: ['bg-surface-hover', 'rounded-lg', 'dark:bg-carbon-500'],
          false: ['border-b-4', 'border-surface-primary', 'bg-white', 'dark:bg-surface-elevated'],
        },
        law: {
          true: ['sticky', 'top-0', 'mb-4', '!pb-0', 'z-[9]', '!pt-0'],
        },
        isTop: {
          false: ['!pt-0'],
        },
        // NS sections (punkter) reuse the law's default chrome (heavy bottom
        // border + rounded selected bg). Deeper nodes drop the border so the
        // content under a punkt reads as one continuous block.
        nsNested: {
          deep: ['!border-0', '!pb-2xs'],
        },
      },
    }),
  },

  section: {
    base: cva([
      'flex',
      'flex-col',
      'px-m',
      '[&:has(+[id*=footnotes-container])]:mb-3xs',
    ], {
      variants: {
        type: {
          footnotes: ['gap-3xs'],
          subsections: ['gap-xs'],
        },
      },
    }),
  },

  subsection: {
    base: cva([
      'rounded-lg',
      'dark:text-white',
    ], {
      variants: {
        selected: {
          true: ['font-semibold'],
          false: [],
        },
        type: {
          note: [],
          commentary: [],
          law: [],
          chapter: [],
          section: [],
          subsection: [
            '[&>div]:indent-s',
            '[&>div>ul]:flex',
            '[&>div>ul]:flex-col',
            '[&>div>ul]:gap-xs',
            '[&>div>ol]:flex',
            '[&>div>ol]:flex-col',
            '[&>div>ol]:gap-xs',
            '[&>div>ol]:my-xs',
            '[&>div>ol>li>span]:mr-xs',
            '[&>div>ol>li>ul]:ml-m',
            '[&>div>ol>li>ul]:flex',
            '[&>div>ol>li>ul]:flex-col',
            '[&>div>ol>li>ul]:gap-xs',
            '[&>div>ol>li>ul>li>span]:mr-xs',
          ],
          del: [],
          paragraph: [],
          content_supplement: [],
          legal_commentary: [],
          legal_commentary_section: [],
          footnote: [],
          unknown: [],
        },
      },
    }),
  },

  note: {
    base: cva([
      'flex',
      'gap-2xs',
      '[&_*]:text-caption',
    ]),
  },

  footnote: {
    base: cva([
      'flex',
      'gap-2xs',
      '[&_*]:text-caption',
    ]),
  },
}
